<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <label for="">起</label>
            <date-picker format="YYYY-MM-DD" class="w-100"> </date-picker>
          </div>
          <div class="col-sm-3 col-md-3">
            <label for="">迄</label>
            <date-picker format="YYYY-MM-DD" class="w-100"> </date-picker>
          </div>
          <div class="col-sm-3 col-md-3">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
            >
              查詢
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="scheduleTotalData"
        @on-change-query="onChangeSchedule"
      >
      </VueBootstrap4Table>
    </div>
  </div>
</template>

<script>
import { config } from "@/components/back/table_config.js";

export default {
  data() {
    return {

      rows: [
        {
          title: '[開發區]',
          Email: '姓名: Alice，Email: Alice@yahome.com',
          result: '是',
          message: '',
          time: '2022-04-07 18:03:13',
        },
        {
          title: '[測試區]',
          Email: '姓名: Bella，Email: Bella@yahome.com',
          result: '是',
          message: '',
          time: '2022-05-07 09:40:48',
        }
      ],

      columns: [
        {
          label: "信件標題",
          name: "title",
        },
        {
          label: "收件人Email",
          name: "Email",
        },
        {
          label: "是否成功",
          name: "result",
        },
        {
          label: "錯誤訊息",
          name: "message",
        },
        {
          label: "寄信時間",
          name: "time",
        },
      ],

      scheduleTotalData: 0,

      config: {
        ...config
      },

    };
  },
  methods: {
    onChangeSchedule() {}
  },
};
</script>
